import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import {withStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import '@scss/page_login.scss';
import Link from '@material-ui/core/Link';
import {resetPassword} from '@componentDP/js_react/redux/actions/login';
import Button from '@material-ui/core/Button';
import {TextField} from '@material-ui/core';
import {delay} from '@helpers/functions';
import {getJsonFromUrl} from '@assets/js/helpers/functions';
import {withTranslation} from "react-i18next";

const styles = theme => ({
    themeDirection: theme.direction,
    h4: {
        fontWeight: 'bold',
        paddingBottom: '20px',
    },
    loginBtn: {
        backgroundColor: '#009be5',
        width: '100%',
        padding: '15px 0px',
        color: 'white',
        fontWeight: 'bold',
        fontSize: '14px',
        '&:hover': {
            backgroundColor: '#0082c0',
        }
    },
});

class PageAuthResetPasswordContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            password: '',
            password_confirmation: '',
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleResetPassword = this.handleResetPassword.bind(this);
    }
    handleChange(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({[name]: value});
    };
    handleLogin() {
        location.hash = '/';
    };
    handleResetPassword() {
        const {resetPassword, t} = this.props;
        const {password, password_confirmation} = this.state;
        const getParams = getJsonFromUrl(location.search);

        const data = {
            password,
            password_confirmation,
            token: getParams.token,
            email: getParams.email,
        };
        delay(() => {
            resetPassword(data, t);
        }, 200);
    };
    render() {
        const {handleChange, handleLogin, handleResetPassword} = this;
        const {classes, t} = this.props;
        const {password, password_confirmation} = this.state;
        return(
            <form>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography align="center" variant="h6">
                            {t('reset_password')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            type="password"
                            label={t('new_password')}
                            variant="outlined"
                            fullWidth
                            size="small"
                            name="password"
                            value={password}
                            onChange={(e) => {
                                handleChange(e);
                            }} />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            type="password"
                            label={t('confirm_password')}
                            variant="outlined"
                            fullWidth
                            size="small"
                            name="password_confirmation"
                            value={password_confirmation}
                            onChange={(e) => {
                                handleChange(e);
                            }} />
                    </Grid>
                    <Grid item xs={12} className={classes.alignCenter}>
                        <Button variant="contained" onClick={() => {handleResetPassword()}} className={classes.loginBtn}>
                            {t('change_password')}
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <Link className="cursor-pointer" onClick={() => {handleLogin()}}>
                            <Typography variant="body1" align="center">
                                {t('back_to_login_form')}
                            </Typography>
                        </Link>
                    </Grid>
                </Grid>
            </form>
        );
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        resetPassword,
    }, dispatch);
}

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(withTranslation()(PageAuthResetPasswordContainer));
